(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["video-reels"] && !Shopify.designMode) return;
  try {
    class VideoReels extends HTMLElement {
    connectedCallback() {
      this.onClick = this.onClick.bind(this);
      this.addEventListener('click', this.onClick);
      this.setupPreviews();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.teardownPreviews();
    }

    /* Click: open the shared fullscreen player on the clicked video. */
    onClick(event) {
      const hit = event.target instanceof Element ? event.target.closest('[data-vr-open]') : null;
      if (!hit) return;

      const cards = Array.from(this.querySelectorAll('[data-vr-card][data-full]'));
      const index = cards.indexOf(hit.closest('[data-vr-card]'));
      if (index < 0) return;

      const isPhone = window.matchMedia('(max-width: 749px)').matches;
      const videos = cards.map((card) => ({
        videoUrl: (isPhone && card.dataset.mobile) || card.dataset.full,
        coverUrl: card.dataset.cover || '',
        caption: '',
      }));
      const open = () =>
        window.ReelsVideoPlayer.open(videos, index, {
          preloadAdjacent: this.dataset.preloadAdjacent || 'desktop',
        });

      /* The player is a deferred script; a click that beats it waits for it. */
      if (window.ReelsVideoPlayer) open();
      else document.addEventListener('rvp:ready', open, { once: true });
    }

    /* Muted in-view previews. Desktop only, and never for shoppers who asked
       for less motion or less data: for them the cards stay posters. */
    setupPreviews() {
      if (this.dataset.autoplay !== 'true' || !('IntersectionObserver' in window)) return;
      if (!window.matchMedia('(min-width: 750px)').matches) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      if (navigator.connection && navigator.connection.saveData) return;

      this.previewSeconds = parseFloat(this.dataset.previewSeconds || '') || 4;
      this.visibleCards = new Set();
      this.playerOpen = false;

      this.observer = new IntersectionObserver(
        (entries) => {
          for (const entry of entries) {
            if (entry.isIntersecting) {
              this.visibleCards.add(entry.target);
              this.playPreview(entry.target);
            } else {
              this.visibleCards.delete(entry.target);
              this.releasePreview(entry.target);
            }
          }
        },
        { threshold: 0.5 }
      );
      this.querySelectorAll('[data-vr-card][data-preview]').forEach((card) => this.observer.observe(card));

      /* Previews stop while the fullscreen player is open or the tab is hidden. */
      this.onPlayerOpen = () => {
        this.playerOpen = true;
        this.releaseAll();
      };
      this.onPlayerClose = () => {
        this.playerOpen = false;
        this.resumeVisible();
      };
      this.onVisibilityChange = () => {
        if (document.hidden) this.releaseAll();
        else this.resumeVisible();
      };
      document.addEventListener('rvp:open', this.onPlayerOpen);
      document.addEventListener('rvp:close', this.onPlayerClose);
      document.addEventListener('visibilitychange', this.onVisibilityChange);
    }

    teardownPreviews() {
      if (!this.observer) return;
      this.observer.disconnect();
      this.observer = null;
      this.releaseAll();
      this.visibleCards.clear();
      document.removeEventListener('rvp:open', this.onPlayerOpen);
      document.removeEventListener('rvp:close', this.onPlayerClose);
      document.removeEventListener('visibilitychange', this.onVisibilityChange);
    }

    playPreview(card) {
      if (this.playerOpen || document.hidden) return;

      let video = card.querySelector('video');
      if (!video) {
        video = document.createElement('video');
        video.className = 'video-reels__preview';
        video.muted = true;
        video.loop = true;
        video.playsInline = true;
        video.preload = 'none';
        video.tabIndex = -1;
        video.setAttribute('muted', '');
        video.setAttribute('playsinline', '');
        video.setAttribute('aria-hidden', 'true');
        video.addEventListener('playing', () => card.classList.add('is-playing'));
        /* Loop only the first few seconds, so the browser never streams the
           whole file for a preview. */
        video.addEventListener('timeupdate', () => {
          if (video.currentTime >= this.previewSeconds) video.currentTime = 0;
        });
        card.insertBefore(video, card.querySelector('[data-vr-open]'));
      }

      if (!video.getAttribute('src')) video.src = card.dataset.preview;
      const playing = video.play();
      if (playing) playing.catch(() => {});
    }

    /* A paused <video> keeps downloading its file in the background. Dropping
       the src stops the download; the poster underneath stays visible. */
    releasePreview(card) {
      const video = card.querySelector('video');
      if (!video) return;
      video.pause();
      card.classList.remove('is-playing');
      if (video.getAttribute('src')) {
        video.removeAttribute('src');
        video.load();
      }
    }

    releaseAll() {
      this.visibleCards.forEach((card) => this.releasePreview(card));
    }

    resumeVisible() {
      this.visibleCards.forEach((card) => this.playPreview(card));
    }
  }

  if (!customElements.get('video-reels')) {
    customElements.define('video-reels', VideoReels);
  }
  } catch(e) { console.error(e); }
})();

})();
